import { Link } from "react-router-dom";

const CATEGORIES = [
  {
    title: "电影作品",
    to: "/works?type=movie",
    desc: "剧情、悬疑、科幻、文艺，跨越多种题材的银幕之旅",
    icon: "ri-film-line",
    count: "6 部",
  },
  {
    title: "电视剧作品",
    to: "/works?type=tv",
    desc: "治愈、都市、家庭、悬疑，陪伴你度过每个夜晚",
    icon: "ri-live-line",
    count: "4 部",
  },
];

export default function CategoryEntries() {
  return (
    <section className="px-5 md:px-10 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
            Categories
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            作品分类快捷入口
          </h2>
        </div>
        <p className="text-sm text-foreground-500 max-w-md">
          按类型快速找到你想看的作品，电影与电视剧一目了然。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
        {CATEGORIES.map((category) => (
          <Link
            key={category.to}
            to={category.to}
            className="group relative flex items-center gap-5 p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
          >
            <span className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-500 text-background-50 flex-shrink-0">
              <i className={`${category.icon} text-2xl md:text-3xl`} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950">
                  {category.title}
                </h3>
                <span className="px-2 py-0.5 rounded-md text-[11px] bg-accent-100 text-accent-800">
                  {category.count}
                </span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {category.desc}
              </p>
            </div>
            <i className="ri-arrow-right-line text-xl text-foreground-300 group-hover:text-accent-500 group-hover:translate-x-1 transition-all flex-shrink-0" />
          </Link>
        ))}
      </div>
    </section>
  );
}